/* Ardor DTF Designer: cloud storage client (assets/ardor-dtf-upload.js). New Oct 14, 2026.
   Loaded by sections/ardor-dtf-builder-ws.liquid before assets/ardor-dtf-builder.js.

   Uses the tent designer's existing upload Worker exactly as it is (nothing in the Worker or the bucket changed for this):
     PUT  <base>/u/<prefix>/<32 hex>/<name>   body = the file, only a Content-Type header
     link <base>/f/<prefix>/<32 hex>/<name>   (or the url the Worker answers with)
   The same calls the tent designer makes (assets/ardor-tent-tentCheckout.min.js). The Worker takes PDF, JPG, PNG, WebP,
   JSON and ZIP files up to 100 MB each, only from Ardor's site, and never lists files; the 32 hex characters are a new
   random folder per order, so links can't be guessed. The bucket's rules keep print/ 90 days and designs/ 2 years.

   window.ArdorDtfUpload.put(blob, { kind, name, onProgress }) -> Promise<{ url, key, size, type, zipped }>
     kind 'print' (print PNG, PDF copy) and 'proof' (signed proof) -> print/;  'original' (the customer's files) -> designs/
     Originals the Worker does not take (SVG, AI, EPS, PSD, TIFF) go up inside a .zip (one stored entry, unchanged bytes).
     Errors carry .code: 'too-big' (over 100 MB), 'type', 'network', 'http' (.status), 'empty'.
   window.ArdorDtfUpload.newOrder() starts a new folder (the cart calls it once per Add to cart).
*/
(function () {
  'use strict';
  if (window.ArdorDtfUpload) return;
  var BASE = 'https://ardor-tent-uploads.dayne-18a.workers.dev';
  var MAX = 100 * 1000 * 1000;
  var TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp', 'application/json', 'application/zip'];
  var EXT = { 'application/pdf': 'pdf', 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'application/json': 'json', 'application/zip': 'zip' };
  var BY_EXT = { pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', json: 'application/json', zip: 'application/zip' };
  var PREFIX = { print: 'print', proof: 'print', original: 'designs', design: 'designs' };
  var RETRY = [500, 2000];
  var folder = null, used = {};

  function fail(code, msg, extra) { var e = new Error(msg); e.code = code; if (extra) for (var k in extra) e[k] = extra[k]; return e; }
  function hex(n) {
    var a = new Uint8Array(n);
    (window.crypto || window.msCrypto).getRandomValues(a);
    return Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
  }
  function newOrder() { folder = hex(16); used = {}; return folder; }
  function extOf(name) { var m = /\.([A-Za-z0-9]{1,5})$/.exec(String(name || '')); return m ? m[1].toLowerCase() : ''; }
  // the Worker's own name rule (same as the tent designer): letters, digits, _ . space ( ) - ; starts with a letter or digit; 120 max
  function clean(name, ext) {
    var base = String(name || '').replace(/\.[A-Za-z0-9]{1,5}$/, '');
    var tail = ext ? '.' + ext : '';
    base = base.replace(/[^\w. ()-]+/g, '').replace(/^[^\w]+/, '').replace(/\s+/g, ' ').trim().slice(0, 120 - tail.length);
    return (base || 'file') + tail;
  }
  function unique(prefix, name) {
    var m = name, i = 2;
    while (used[prefix + '/' + m]) { m = name.replace(/(\.\w+)?$/, function (x) { return ' (' + i + ')' + (x || ''); }); i++; }
    used[prefix + '/' + m] = 1;
    return m;
  }
  function typeOf(blob, name) {
    var t = String(blob.type || '').toLowerCase();
    if (t === 'image/jpg') t = 'image/jpeg';
    if (TYPES.indexOf(t) >= 0) return t;
    if (!t || t === 'application/octet-stream') return BY_EXT[extOf(name || blob.name)] || t || 'application/octet-stream';
    return t;
  }

  // ---------- a one-file .zip (stored, no compression) for originals the Worker does not take ----------
  var CRC = null;
  function crc32(u8) {
    if (!CRC) { CRC = new Int32Array(256); for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; CRC[n] = c; } }
    var x = -1;
    for (var i = 0; i < u8.length; i++) x = CRC[(x ^ u8[i]) & 255] ^ (x >>> 8);
    return (x ^ -1) >>> 0;
  }
  function zipOne(blob, inner) {
    return blob.arrayBuffer().then(function (buf) {
      var data = new Uint8Array(buf), nm = new TextEncoder().encode(inner), crc = crc32(data), d = new Date();
      var time = (d.getHours() << 11) | (d.getMinutes() << 5) | (d.getSeconds() >> 1);
      var date = ((d.getFullYear() - 1980) << 9) | ((d.getMonth() + 1) << 5) | d.getDate();
      var lh = new DataView(new ArrayBuffer(30));
      lh.setUint32(0, 0x04034b50, true); lh.setUint16(4, 20, true); lh.setUint16(6, 0x0800, true); lh.setUint16(8, 0, true);
      lh.setUint16(10, time, true); lh.setUint16(12, date, true); lh.setUint32(14, crc, true);
      lh.setUint32(18, data.length, true); lh.setUint32(22, data.length, true); lh.setUint16(26, nm.length, true); lh.setUint16(28, 0, true);
      var ch = new DataView(new ArrayBuffer(46));
      ch.setUint32(0, 0x02014b50, true); ch.setUint16(4, 20, true); ch.setUint16(6, 20, true); ch.setUint16(8, 0x0800, true); ch.setUint16(10, 0, true);
      ch.setUint16(12, time, true); ch.setUint16(14, date, true); ch.setUint32(16, crc, true);
      ch.setUint32(20, data.length, true); ch.setUint32(24, data.length, true); ch.setUint16(28, nm.length, true);
      ch.setUint32(42, 0, true);
      var end = new DataView(new ArrayBuffer(22));
      end.setUint32(0, 0x06054b50, true); end.setUint16(8, 1, true); end.setUint16(10, 1, true);
      end.setUint32(12, 46 + nm.length, true); end.setUint32(16, 30 + nm.length + data.length, true);
      return new Blob([lh, nm, data, ch, nm, end], { type: 'application/zip' });
    });
  }

  // ---------- one PUT, with progress ----------
  function once(url, blob, type, onProgress) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('PUT', url);
      x.setRequestHeader('Content-Type', type);
      if (onProgress && x.upload) x.upload.onprogress = function (e) { if (e.lengthComputable && e.total) { try { onProgress(e.loaded / e.total); } catch (er) {} } };
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) { var j = null; try { j = JSON.parse(x.responseText); } catch (e) {} resolve(j || {}); return; }
        reject(fail(x.status === 413 ? 'too-big' : x.status === 415 ? 'type' : 'http', 'Upload failed (' + x.status + ')', { status: x.status }));
      };
      x.onerror = function () { reject(fail('network', 'Network error during upload')); };
      x.onabort = function () { reject(fail('network', 'Upload stopped')); };
      x.send(blob);
    });
  }
  function sendWithRetry(url, blob, type, onProgress) {
    var n = 0;
    function go() {
      return once(url, blob, type, onProgress).catch(function (e) {
        var again = e.code === 'network' || (e.code === 'http' && (e.status >= 500 || e.status === 408 || e.status === 429));
        if (!again || n >= RETRY.length) throw e;
        var wait = RETRY[n++];
        return new Promise(function (r) { setTimeout(r, wait); }).then(go);
      });
    }
    return go();
  }

  function put(blob, opts) {
    opts = opts || {};
    if (!blob || typeof blob.size !== 'number' || !blob.size) return Promise.reject(fail('empty', 'No file to upload.'));
    var prefix = PREFIX[opts.kind] || 'print';
    if (!folder) newOrder();
    var name = opts.name || blob.name || 'file';
    var type = typeOf(blob, name);
    var ready;
    if (TYPES.indexOf(type) >= 0) {
      var ext = extOf(name);
      if (BY_EXT[ext] !== type) ext = EXT[type];
      ready = Promise.resolve({ blob: blob, type: type, name: clean(name, ext), zipped: false });
    } else {
      if (blob.size > MAX - 1024) return Promise.reject(fail('too-big', 'Over the 100 MB upload limit.', { size: blob.size }));
      var inner = clean(name, extOf(name));
      ready = zipOne(blob, inner).then(function (z) { return { blob: z, type: 'application/zip', name: clean(inner + '.zip', 'zip'), zipped: true }; });
    }
    return ready.then(function (f) {
      if (f.blob.size > MAX) throw fail('too-big', 'Over the 100 MB upload limit.', { size: f.blob.size });
      var file = unique(prefix, f.name);
      var key = prefix + '/' + folder + '/' + file;
      var link = BASE + '/f/' + prefix + '/' + folder + '/' + encodeURIComponent(file);
      return sendWithRetry(BASE + '/u/' + prefix + '/' + folder + '/' + encodeURIComponent(file), f.blob, f.type, opts.onProgress).then(function (j) {
        if (j && j.ok === false) throw fail('http', 'Upload refused');
        // the Worker answers with the link unencoded (spaces in it); encode spaces and brackets so the link in the order stays one link
        var url = j && typeof j.url === 'string' && /^https:\/\/[^\s]/.test(j.url) ? j.url.replace(/ /g, '%20').replace(/\(/g, '%28').replace(/\)/g, '%29') : link.replace(/\(/g, '%28').replace(/\)/g, '%29');
        return { url: url, key: key, size: f.blob.size, type: f.type, zipped: f.zipped };
      });
    });
  }

  window.ArdorDtfUpload = { put: put, newOrder: newOrder, maxBytes: MAX, types: TYPES.slice(), base: BASE };
})();
